import { render, staticRenderFns } from "./EstacJuninFormType.vue?vue&type=template&id=c1da6d0e&"
import script from "./EstacJuninFormType.vue?vue&type=script&lang=js&"
export * from "./EstacJuninFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports